/* eslint-disable react-hooks/exhaustive-deps */
/**
 * Main container
 * imported in App.js
 */
import React, { useEffect, useState } from "react";
import "./pageHeader.css";
import { withRouter } from "react-router-dom";
import { Box, Divider } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import SearchableMultiSelect from "../../widgets/searchableMultiSelectDropdown/searchableMultiSelect";
import { cityOperatorsListAction } from "../../../redux/action-creators/operatorActionCreator";
import { selectedCity } from "../../../redux/actions/citiesAction";
import { selectedOperator as selectedOperatorAction } from "../../../redux/actions/operatorsAction";

const useComponentLogic = () => {
  const dispatch = useDispatch();

  const operatorFilter = useSelector((state) => state.Operators.selectedOperator);
  const cityFilter = useSelector((state) => state.Cities.selectedCity);

  const [selectedOperator, setSelectedOperator] = useState(operatorFilter);
  const [selectedCities, setSelectedCities] = useState(cityFilter);

  useEffect(() => {
    if (selectedCities.length > 0 || cityFilter.length > 0) {
      const citiesArray = selectedCities.map((city) => city.toString());
      dispatch(selectedCity(citiesArray));
      dispatch(cityOperatorsListAction({ cityIdArr: citiesArray }, "loader"));
    }
  }, [selectedCities]);

  useEffect(() => {
    if (selectedOperator.length > 0 || operatorFilter.length > 0) {
      dispatch(
        selectedOperatorAction(
          selectedOperator.map((operator) => operator.toString()),
        ),
      );
    }
  }, [selectedOperator]);

  const cities = useSelector((state) => state.Cities.cities.map(
    (city) => ({ ...city, cityId: city.cityId.toString() }),
  ));
  const operators = useSelector((state) => (state.Operators.cityOperators.length > 0
    ? state.Operators.cityOperators
    : state.Operators.operators));

  const handleOperatorChange = (newSelectedOperator) => {
    setSelectedOperator(newSelectedOperator);
  };

  const handleCitiesChange = (newSelectedCities) => {
    handleOperatorChange([]);
    setSelectedCities(newSelectedCities);
  };

  return {
    cities, operators, handleOperatorChange, handleCitiesChange, selectedOperator, selectedCities,
  };
};

function PageHeader(props) {
  const {
    isHeaderFixed = true,
    hideDivider = false,
    hideLower = false,
    customClass = "",
    removeUpperHeader,
    removeFilterOnly,
    children,
    showBackArrow,
    history,
    heading,
    hideS,
  } = props;

  const {
    cities, operators, handleOperatorChange, handleCitiesChange, selectedOperator, selectedCities,
  } = useComponentLogic();

  return (
    <Box
      class={`${
        isHeaderFixed ? "header-wrapper-fixed" : "header-wrapper"
      } ${hideLower ? "only-upper" : ""} ${customClass}`}
    >
      {!removeUpperHeader && (
        <>
          <Box className="upper-header">
            <Box className="upper-left">
              {showBackArrow && (
                <Box
                  className="back-arrow"
                  onClick={() => {
                    history?.goBack();
                  }}
                >
                  <Box className="back-action" />
                </Box>
              )}
              {heading && (
                <Box className="page-header-title">
                  {heading}
                  {!hideS && <span>s</span>}
                </Box>
              )}
            </Box>
            {!removeFilterOnly && (
              <Box className="upper-right">
                <SearchableMultiSelect
                  name="Operators"
                  label="Select Operators"
                  options={operators}
                  value={selectedOperator}
                  onChange={handleOperatorChange}
                  keyField="operatorId"
                  valueField="operatorName"
                  displayLimit={2000}
                />
                <SearchableMultiSelect
                  name="Cities"
                  label="Select Cities"
                  options={cities}
                  value={selectedCities}
                  onChange={handleCitiesChange}
                  keyField="cityId"
                  valueField="cityName"
                  displayLimit={100}
                />
              </Box>
            )}
          </Box>
          <Divider className={`${!hideDivider ? "" : "display-none"}`} />
        </>
      )}
      <Box className={`lower-header ${!hideLower ? "" : "display-none"}`}>
        {children}
        <div className="clear-float" />
      </Box>
    </Box>
  );
}

export default withRouter(PageHeader);
